<template>
  <v-autocomplete
    hide-details="auto"
    :items="Kitchen"
    :loading="loading"
    v-model="selectedKitchen"
    item-text="name"
    item-value="id"
    label="Kitchen"
    clearable
    outlined
    dense
    @change="emitInput"
    :search-input.sync="searchKitchen"
  ></v-autocomplete>
</template>
<script>
export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    Kitchen: [],
    selectedKitchen: null,
    searchKitchen:null,
    loading:false
  }),
  methods: {
    emitInput() {
      this.$emit("input", this.selectedKitchen);
    },
    getKitchenByQuery(query = "") {
        
      this.loading = true;
      this.$store
        .dispatch("Kitchen/Get", {
          query: query,
          status: "active",
        })
        .then((res) => {
          this.Kitchen = res.data.data
          this.loading = false;

        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedKitchen = null;
      },
      deep: true,
    },
    searchKitchen: {
      handler(val) {
        this.getKitchenByQuery(val);
      },
      deep: true,
    },
  },
  created(){
    this.getKitchenByQuery()
  }
};
</script>